import * as c from './types';

import createReducer from '../../reducers/utils/createReducer';

export interface WorkOrderShort {
  value: string;
  label: string;
}

export type WorkOrderNameState = OptionsDataState<WorkOrderShort>;

export interface OptionsDataState<T> {
  data: T[];
  totalItems: number;
  isLoading: boolean;
}

const initialState: WorkOrderNameState = {
  data: [],
  isLoading: false,
  totalItems: 0
};

export default createReducer(initialState, {
  [c.FETCH_WORK_ORDER_NAME_REQUEST]: (state = initialState) => ({
    ...state,
    error: null,
    isLoading: true
  }),
  [c.FETCH_WORK_ORDER_NAME_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      ...payload,
      error: null,
      isLoading: false
    };
  },
  [c.FETCH_WORK_ORDER_NAME_ERROR]: (
    state = initialState,
    action: { type: string; payload?: any }
  ) => {
    if (!action.payload) return state;
    return {
      ...state,
      error: action.payload,
      isLoading: false
    };
  }
});
